import { render, staticRenderFns } from "./InstructionsListElement.vue?vue&type=template&id=da7007da&scoped=true&"
import script from "./InstructionsListElement.vue?vue&type=script&scoped=true&lang=js&"
export * from "./InstructionsListElement.vue?vue&type=script&scoped=true&lang=js&"
import style0 from "./InstructionsListElement.vue?vue&type=style&index=0&id=da7007da&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da7007da",
  null
  
)

export default component.exports